import type { ReactNode } from "react";
import { EventRow, type SecurityEvent } from "./EventRow";

interface Props {
  events: SecurityEvent[];
  emptyMessage: string;
  rowAction?: (e: SecurityEvent) => ReactNode;
  onOpenEvent?: (e: SecurityEvent) => void;
  header?: ReactNode;
}

export function QueueTable({ events, emptyMessage, rowAction, onOpenEvent, header }: Props) {
  return (
    <div className="sr-queue-table">
      {header}
      {events.length === 0 ? (
        <div className="sr-empty">{emptyMessage}</div>
      ) : (
        events.map((e) => (
          <EventRow
            key={e.id}
            event={e}
            action={rowAction?.(e)}
            onOpen={onOpenEvent ? () => onOpenEvent(e) : undefined}
          />
        ))
      )}
    </div>
  );
}
